import React from 'react';
import { DateTime, Duration } from 'luxon';
import { RichText } from 'prismic-reactjs';
import { Row, Col } from 'react-bootstrap';
import Layout from '../components/Layout';
import OpenGraphTitle from '../components/OpenGraphTitle';
import OpenGraphDescription from '../components/OpenGraphDescription';
import Head from '../components/head';
import Section from '../components/Section';
import PageTitle from '../components/PageTitle';
// import TermsAndConditionsContent, {} from '../components/TermsAndConditionsContent';
import { FranchiseeProvider } from '../context/Franchisee';
import { PrismicClient } from '../SDKs/Prismic/prismic.config';
import htmlSerializer from '../SDKs/Prismic/htmlSerializer';

export const getStaticProps = async (context) => {
  const { req } = context;
  const termsAndConditions = await PrismicClient(req).getSingle(
    'terms-and-conditions',
    {}
  );
  const revalidate = Duration.fromObject({ week: 1 }).as('seconds');

  return {
    props: {
      termsAndConditions,
    },
    revalidate,
  };
};

interface TermsAndConditionsPageProps {
  /* add terms and conditions page props here */
  termsAndConditions: any;
}

const TermsAndConditions: React.FC<TermsAndConditionsPageProps> = ({
  termsAndConditions,
}: TermsAndConditionsPageProps) => {
  const lastUpdated = DateTime.fromISO(
    termsAndConditions.last_publication_date
  );
  const { content } = termsAndConditions.data;
  return (
    <FranchiseeProvider>
      <Layout alternateFooter>
        <Head
          slug='terms-and-conditions'
          title='Terms And Conditions | Two Maids'
          description={`Two Maids' Terms & Conditions.`}
        />
        <OpenGraphTitle title='Terms And Conditions | Two Maids' />
        <OpenGraphDescription>
          {/* Add Terms And Conditions description here */}
          Two Maid's Terms &amp; Conditions.
        </OpenGraphDescription>
        <Section>
          <Row className='justify-content-center'>
            <Col xs={12} lg={10} xl={9}>
              <div className='mb-3'>
                <PageTitle>Terms and Conditions</PageTitle>
                <span className='text-uppercase font-weight-bold'>
                  Last Updated {lastUpdated.toLocaleString(DateTime.DATE_FULL)}
                </span>
              </div>
              <RichText render={content} htmlSerializer={htmlSerializer} />
              <span className='text-uppercase font-weight-bold'>
                Last Updated {lastUpdated.toLocaleString(DateTime.DATE_FULL)}
              </span>
            </Col>
          </Row>
        </Section>
      </Layout>
    </FranchiseeProvider>
  );
};

export default TermsAndConditions;
